
// This avoids adding an extra prod dependency like `cn` just to concatenate classNames.
export const joinClassNames = (...args) => args.join(' ').trim();

export const getAssetTitle = (asset) =>
  asset.name || `#${asset.token_id}`;

export const isEnsDomain = (ownerAddress) =>
  ownerAddress.includes('.eth');
